<input-search id="inputSearchElement" [data]="config.data" [position]="false" [placeholder]="config.data.hint"
    [clearSearchResult]="clearSearchResult" (patientResult)="settingUserInfo($event)" [showAdvSearch]="config.data.advanceSearch"
    (labelEvent)="InputEvent($event);" (closeOverlay)="closesOverlay();">
</input-search>